import type { IItem } from "@Front/Components/DesignSystem/Menu/MenuItem";
import type { MenuRulePermissionCanFn } from "./permissionCanTypes";

export type { MenuRulePermissionCanFn };

/**
 * Aligné sur Rules (mode NECESSARY) : chaque règle de l'item doit être accordée via can() (matrice).
 * Items sans propriété rules conservés (sous-menus métier sans garde matrix sur l'entrée).
 * Côté React, préférer `useMatrixFilteredMenuItems` (Menu / burger) plutôt que d'appeler cette fonction seule.
 */
export function filterMenuItemsByCan(items: IItem[], can: MenuRulePermissionCanFn): IItem[] {
	return items.filter((item) => {
		const rules = item.rules ?? [];
		if (rules.length === 0) {
			return true;
		}
		return rules.every((rule) => can(rule.name, rule.action));
	});
}
